import React from 'react'
import BaseStep from '../BaseStep'
import CardSelectable from '../commons/CardSelectable'
import Back from '../commons/Back'
import GenericIcon from 'components/GenericIcon'

class HasFoundHome extends BaseStep {

  onClick = (answer) => {
    this.props.onChoice({ hasFoundHome: answer })
  }


  question = () => {
    return I18n.t(`onboarding.has_found_home.${this.props.loanTarget}.question`)
  }

  render() {
    return (
      <div ref={ (ref) => this.cardsContainer = ref } >
        <h3 className="onboarding-title text-center">
          { this.question() }
        </h3>
        <div className="row">
          <div className="col-sm-6">
            <CardSelectable
              onClick={ () => this.onClick(true) }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='homeStar' />
              <h4>{ I18n.t(`onboarding.has_found_home.${this.props.loanTarget}.answer.true`) }</h4>
            </CardSelectable>
          </div>
          <div className="col-sm-6">
            <CardSelectable
              onClick={ () => this.onClick(false) }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='search' />
              <h4>{ I18n.t(`onboarding.has_found_home.${this.props.loanTarget}.answer.false`) }</h4>
            </CardSelectable>
          </div>
        </div>
        <Back onGoBack={this.props.onGoBack} />
      </div>
    )
  }
}

export default HasFoundHome;
